import React, { useState, useRef } from 'react'
import {
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Avatar,
    IconButton
} from '@mui/material'

import {
    Settings,
    LightMode,
    DarkMode,
    Logout,
    Report,
    ReportProblem,
} from '@mui/icons-material'

import ChocolateAccount from './ChocolateAccount'
import ReportDialog from '../pages/chats/ReportDialog'
import { removeToken, clearSessionData } from "../utils/tokenUtils";
import { userLogout } from '../services/AuthApi'


const AccountSetting = ({ user, setUser, refreshUser, navigate, setMobileOpen }) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const pendingNavRef = useRef(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuExited = () => {
        if (pendingNavRef.current) {
            navigate(pendingNavRef.current);
            pendingNavRef.current = null;
        }
    };

    const [openDialog, setOpenDialog] = useState(false);

    const handleSignout = () => {
        console.log("Logout");

        // GTM tracking for logout
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "logout",
            userId: user?.id,
            accountType: user?.account_type,
        });

        userLogout()
            .then((response) => {
                console.log(response);
                // Clear token for current context (PWA or browser) only
                removeToken();
                clearSessionData();
                handleClose();
                navigate("/", { replace: true });
                window.location.reload();
            })
            .catch((error) => {
                console.error(error);
            });
    };

    return (
        <React.Fragment>
            <IconButton
                id="account-button"
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                sx={{ display: { xs: "none", md: "flex" }, backgroundColor: theme => theme.palette.action.hover }}
            >
                <Avatar
                    src={user?.thumbnail_pic}
                    alt={user?.name}
                    sx={{ width: 24, height: 24 }}
                />

            </IconButton>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionProps={{ onExited: handleMenuExited }}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            borderRadius: 4,
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <React.Fragment>
                    <ChocolateAccount
                        user={user}
                        handleCloseDesktopmenu={handleClose}
                        setUser={setUser}
                        refreshUser={refreshUser}
                        navigate={navigate}
                        setMobileOpen={setMobileOpen}
                    />

                    <MenuItem onClick={() => { pendingNavRef.current = "/edit-profile"; handleClose(); }}
                        sx={{ p: 1.5 }}
                    >
                        <ListItemIcon>
                            <Settings />
                        </ListItemIcon>
                        <ListItemText primary={user.account_type === "organization" ? "Manage Profile" : "Edit Profile"} />
                    </MenuItem>

                    <MenuItem onClick={() => { setOpenDialog(true); handleClose(); }} sx={{ p: 1.5 }}>
                        <ListItemIcon>
                            <ReportProblem />
                        </ListItemIcon>
                        <ListItemText primary="Report Issue" />
                    </MenuItem>

                    <MenuItem onClick={() => handleSignout()} sx={{ p: 1.5 }}>
                        <ListItemIcon>
                            <Logout />
                        </ListItemIcon>
                        <ListItemText primary="Logout" />
                    </MenuItem>
                </React.Fragment>

            </Menu>

            <ReportDialog open={openDialog} onClose={() => setOpenDialog(false)} />

        </React.Fragment>
    )
}

export default AccountSetting
